/**
 * Camada de rastreamento (dataLayer / GTM).
 * IDs configurados via variáveis de ambiente:
 *   VITE_GTM_ID  — ex: GTM-XXXXXXX
 *   VITE_GA4_ID  — ex: G-XXXXXXXXXX
 */

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export const GTM_ID =
  (import.meta.env.VITE_GTM_ID as string | undefined) ?? "GTM-XXXXXXX"; // TODO: preencher
export const GA4_ID =
  (import.meta.env.VITE_GA4_ID as string | undefined) ?? "G-XXXXXXXXXX"; // TODO: preencher

export type TrackEvent =
  | { event: "click_whatsapp"; source?: string };

export function track(payload: TrackEvent) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(payload);
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log("[dataLayer]", payload);
  }
}
